import React, { useCallback } from 'react';
import { Form } from 'react-final-form';
import { Grid, MenuItem } from '@mui/material';
import { Select } from 'mui-rff';
//
import ButtonSubmit from 'components/common/ButtonSubmit';
import { useGetWLIDDropdownQuery } from '../../../store/api/wl.api';
import { useGetPublishersDropdownQuery } from '../../../store/api/publisher.api';
import { useGetEndpointsDropdownQuery } from '../../../store/api/endpoint.api';
import { filterParamsForm } from 'utils/normalizers';

const FilterPanel = ({ applyFilters, isRequestPending }) => {
  const { data: wlidOptions = [] } = useGetWLIDDropdownQuery();
  const { data: publisherOptions = [] } = useGetPublishersDropdownQuery();
  const { data: endpointOptions = [] } = useGetEndpointsDropdownQuery();

  const onSubmit = useCallback(
    (values) => applyFilters(filterParamsForm(values)),
    [applyFilters],
  );

  return (
    <Form
      onSubmit={onSubmit}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit} noValidate>
          <Grid
            container
            alignItems='flex-end'
            spacing={3}
            wrap='nowrap'
            sx={{ width: '100%' }}
          >
            {/* Client */}
            <Grid sx={{ flex: 1 }}>
              <Select name='wlids' label='Client' multiple fullWidth>
                {wlidOptions.map((item) => (
                  <MenuItem value={item.wlid} key={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            {/* Publisher */}
            <Grid sx={{ flex: 1 }}>
              <Select name='publishers' label='Publisher' multiple fullWidth>
                {publisherOptions.map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            {/* Endpoint */}
            <Grid
              sx={{ flex: 1, display: 'flex', alignItems: 'flex-end', gap: 2 }}
            >
              <Select name='endpoints' label='Endpoint' multiple fullWidth>
                {endpointOptions.map((item) => (
                  <MenuItem value={item.value} key={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>

              <ButtonSubmit
                type='submit'
                loading={isRequestPending}
                name='Apply'
                sx={{ px: 3, flexShrink: 0 }}
              />
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
};

export default FilterPanel;
